// extracted by mini-css-extract-plugin
export default {"conflicts":"conflicts--nNj3o","conflicts__item":"conflicts__item--H85gu","conflictsItem":"conflicts__item--H85gu"};